import axios from 'axios'
import { handleApiError } from '@/api/client'
import type { ApiResponse } from '@/types/api'

export const PRINT_BOOK_DELETE_CONFIRMATION_NOTICE =
  "삭제된 교재는 복구할 수 없습니다.\n\n다른 교재의 '다음 권'으로 연결되어 있거나, 교재 요청·무료 체험 등에서 사용 중인 교재는 삭제할 수 없습니다."

const DELETE_ERROR_MESSAGES: Record<string, string> = {
  PRINT_BOOK_NEXT_LINK_EXISTS:
    "다른 교재가 이 교재를 '다음 권'으로 연결하고 있어 삭제할 수 없습니다. 해당 교재의 연결을 먼저 해제해주세요.",
  PRINT_BOOK_IN_USE:
    '교재 요청, 무료 체험 등 다른 데이터에서 사용 중인 교재라 삭제할 수 없습니다.',
  DATA_INTEGRITY_VIOLATION:
    '다른 데이터에서 사용 중인 교재라 삭제할 수 없습니다.',
  FORBIDDEN:
    '교재를 삭제할 권한이 없습니다.',
}

export function getPrintBookDeleteErrorMessage(error: unknown): string {
  if (axios.isAxiosError<ApiResponse<unknown>>(error)) {
    const code = error.response?.data?.error?.code
    if (code && DELETE_ERROR_MESSAGES[code]) {
      return DELETE_ERROR_MESSAGES[code]
    }
  }

  const message = handleApiError(error)
  return message === 'An unexpected error occurred'
    ? '교재 삭제에 실패했습니다. 잠시 후 다시 시도해주세요.'
    : `교재 삭제에 실패했습니다: ${message}`
}
